import { render } from "./Switch-2.vue?vue&type=template&id=0c937926&scoped=true"
import script from "./Switch-2.vue?vue&type=script&lang=js"
export * from "./Switch-2.vue?vue&type=script&lang=js"

import "./Switch-2.vue?vue&type=style&index=0&id=0c937926&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c937926"]])

export default __exports__